<template>
<app-page-card>
  <template #header>
    <slot name="header-prefix"></slot>
    {{objectType}}
  </template>
  <template #header-actions>
    <table-list-toolbar
      :actions="actions"
      :loading="loadingAction"
      :disabled="disabledActions"
      :show_actions="showActions"
      @job-done="$emit('job-done')"
      @selected-action="selectedAction"
      flat
    >
    <!--  -->
      <template v-slot:initial_btns>                
        <v-btn @click="refreshData()" :loading="objectListLoading" color="primary" icon>
          <v-icon v-once>mdi-refresh</v-icon>
        </v-btn>
        <v-btn v-if="canCreate" @click="createObject()" color="primary" icon>
          <v-icon v-once>mdi-plus</v-icon>
        </v-btn>
      </template> 
      <template v-slot:mid_btns>
        <slot name="mid_btns"></slot>
      </template>
      <template v-slot:end_btns>
        <slot name="end_btns"></slot>
      </template>
    </table-list-toolbar>
  </template>
  <template>
    <v-container fluid>
      <v-row class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <Browser v-if="filtersData.length" iconTop="145px" :fab="true" :filters="filters" :searchFunc="generateFilters" :cleanFunc="cleanFilters" :small="true">
            <template v-slot:inputs>
              <slot name="filters"></slot>
            </template>
          </Browser>

            <!-- <v-row align="center" justify="center">
              <v-col :cols="$vuetify.breakpoint.name!='xs'?'3':'6'">
                {{objectType}}
              </v-col>
              <v-col v-if="$vuetify.breakpoint.name != 'xs'" cols="5">
                <slot name="actions"></slot>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.name!='xs'?'4':'6'">
                <v-row>
                  <v-col cols="6" class="ma-0 pa-0">
                    <v-btn @click="refreshData()" :loading="objectListLoading">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col v-if="canCreate" cols="6" class="ma-0 pa-0">
                    <v-btn @click="createObject()">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->
          
          <v-dialog v-if="deleteDialog" v-model="deleteDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline"></v-card-title>
              <v-card-text>{{ deleteMsg }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined text class="primary-border" @click="noDeleteItem()">No</v-btn>
                <v-btn color="white" text class="primary-bckground" @click="deleteItem()">Si</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-if="errorDialog" v-model="errorDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline"></v-card-title>
              <v-card-text>{{ errorMsg }}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="white" text class="primary-bckground" @click="closeErrorDialog()">Ok</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-row class="pa-0 ma-0">
            <v-col cols="12" class="pa-0 ma-0"> 
              <slot name="select_all"></slot>
            </v-col>
          </v-row>
          <app-row>
            <app-col>
              <v-data-table
                v-model="objectListSelected"
                :headers="headers"
                :items="objectListItems"
                :items-per-page="rowsNumber"
                @click:row="selectRow"
                :multi-sort="false"
                filterable
                :search="search"
                :server-items-length="objectListItemsLength"
                :options.sync="objectListOptions"
                :footer-props="{
                  'items-per-page-options': [5, 10, 100, 1000],
                  'items-per-page-text': objectType + ' por página:',
                }"
                :header-props="{
                  'sort-by-text': 'Ordenar por',
                }"
                :item-class="itemClass"
                :show-select="selectionableRows"
                @update:options="changeOptions"
                @item-selected="$emit('item-selected')"
                @toggle-select-all="$emit('item-selected')"
                :height="tableHeight"
                fixed-header
              >

                <template v-slot:item.actions="{ item }">
                  <v-btn 
                    @click.stop="openDeleteDialog(item)"
                  >
                    <v-icon v-once>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn  v-if="item.metadata && item.metadata.phones" @click.stop="openPhones(item.metadata.phones)"><v-icon v-once>mdi-magnify</v-icon></v-btn>
                </template>

                <!--Footer: Paginación-->
                <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} de {{ items.itemsLength }}
                </template>
              </v-data-table>
            </app-col>
          </app-row>
          
      </v-col>
    </v-row>
  </v-container>
  </template>
  
</app-page-card>
</template>

<script>
import { client } from "@/api/client";
import { mapActions, mapState, mapGetters } from 'vuex';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppCol from '@/components/layout/AppCol.vue';
import Browser from '../components/Browser.vue';
import TableListToolbar from '../components/TableListToolbar.vue';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ListObject',
  components: {
    AppPageCard,
    Browser,
    TableListToolbar,
    AppRow,
    AppCol,
  },
  props: {
    objectType: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    selectRow: {
      type: Function,
      required: true
    },
    headers: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    create: {
      type: String,
      required: true
    },
    filtersData: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    deleteMsg: {
      type: String,
      required: false,
      default: "You will remove this. Are you sure?"
    },
    errorMsg: {
      type: String,
      required: false,
      default: "It was not possible to delete."
    },
    rowsNumber: {
      type: Number,
      required: false,
      default: 5,
    },
    generateFilters: {
      type: Function,
      required: false,
      default: function () {
        return '';
      },
    },
    cleanFilters: {
      type: Function,
      required: false,
      default: function () {
        return '';
      },
    },
    refreshData: {
      type: Function,
      required: false,
      default: function () {
        return '';
      },
    },
    filters: {
      type: String,
      required: false,
      default: '',
    },
    selectionableRows: {
      type: Boolean,
      required: false,
      default: false,
    },

    actions: {
      type: Object,
      required: true,
      default: function () {
        return {};
      }
    },
    loadingAction: {
      type: Boolean,
      default: false,
    },
    disabledActions: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
    itemClass: {
      type: [String, Function],
      required: false,
      default: '',
    },
  },
  data() {
    var returnVal = {
      items: [],
      search: "",
      deleteDialog: false,
      errorDialog: false,
      itemToDelete: null,
      initNumItemsPerPage: 0,
      tableHeight: '59vh',
    };
    this.headers.forEach(function(elem) {
      if (!elem.width) {
        elem.width = elem.text.length * 15;
      }
    });
    return returnVal;
  },
  methods: {
    createObject() {
      this.$router.push(this.create);
    },

    openDeleteDialog(item) {
      this.deleteDialog = true;
      this.itemToDelete = item;
    },
    deleteItem(item) {
      this.deleteDialog = false;
      client.delete(this.objectListBaseUrl + this.itemToDelete.id + "/")
        .then(response => {
          this.refreshData();
          this.itemToDelete = null;
          this.setCompanydbs();
        }).catch(error => {
          this.errorDialog = true;
          this.itemToDelete = null;
        });
    },
    noDeleteItem() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },
    closeErrorDialog() {
      this.errorDialog = false;
    },
    selectedAction(action_id) {
      this.$emit('selected-action', action_id)
    },
    ...mapActions(['setSearch',"setCompanydbs"]),
    changeOptions(){
      this.refreshData();
      this.$emit('rowsPerPage', this.objectListOptions['itemsPerPage'])
    },
    calculateTableHeight() {
        this.initNumItemsPerPage = Math.min(this.rowsNumber, 10);
        if (this.objectListItemsLength == 0) {
            this.tableHeight = '20vh';
        }
        else {
            const rowHeight = document.querySelector('.text-start') && document.querySelector('.text-start').offsetHeight || 48;
            this.tableHeight = rowHeight * (Math.min(this.objectListItemsLength, this.initNumItemsPerPage) + 1).toString() + 'px';
        }
    },
  },
  created() {
    this.objectListOptions = {};
    this.objectListLoading = false;
    this.objectListBaseUrl = this.url;
    this.objectListItems = [];
    this.objectListItemsLength = 0;
    this.objectListSelected = [];

    this.refreshData();
    this.search=this.search_state;
  },
  computed: {
    ...mapState(['search_state', 'currentCompany']),
    ...mapFields(['objectListOptions', 'objectListLoading', 'objectListBaseUrl', 'objectListItems', 'objectListItemsLength', 'objectListSelected', 'totalLengthItems']),
  },
  watch: {
    objectListOptions: {
      handler() {
        this.refreshData();
        this.$emit('rowsPerPage', this.objectListOptions['itemsPerPage'])
      },
      deep: true
    },
    objectListItems: {
      handler() {
        this.calculateTableHeight();
      },
      immediate: true,
    }
  },
};
</script>

<style scoped>
.title-color {
    color:var(--v-primary-base);
}
</style>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }

  ::v-deep .v-data-table-header > tr > th > span{
      color: var(--v-primary-base);
      font-size: 0.875rem;
  }
  ::v-deep .v-data-table-header > tr > th{
      background-color: var(--v-primaryLight-base) !important;
  }
  ::v-deep tbody > tr {
        color: #56565B;
  }
  ::v-deep tbody tr:nth-of-type(even) {
      /* 'deep-orange lighten-5' basides on material design color */
      background-color: rgba(245, 245, 245, 0.47);
  }
  ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
      border-bottom: none !important;
  }

  ::v-deep .v-data-table__wrapper {
      border-radius: 8px;
  }
</style>
<style>
.v-menu__content.menuable__content__active {
  border-radius: 0 0 12px 12px !important; 
}
</style>